export default __webpack_public_path__ + "static/media/iStock3.3556ff9f.jpg";